export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M9.692 13.325a.75.75 0 1 1 1.053 1.069L5.563 19.5h4.203a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75v-5.969a.75.75 0 0 1 1.5 0v4.161l5.192-5.117ZM20.25 3a.75.75 0 0 1 .75.75v5.969a.75.75 0 0 1-1.5 0V5.558l-5.192 5.117a.75.75 0 1 1-1.053-1.069L18.436 4.5h-4.202a.75.75 0 0 1 0-1.5h6.016Z"/>
</svg>
`;
